Scroller = {

	selected : "",

	init: function(){
		this.slides = $('.page-content > .row[url]');
		// console.log("SCROLLER");

		$('.page-content').scroll(function(){

			if(Directory.isScrolling) return;

			Directory.userScrolling = true;
			Submenu.update();

			Scroller.slides.each(function(index, el) {
				Scroller.checkPositions($(this));
			});

			clearTimeout($.data(this, 'scrollTimer'));
		    $.data(this, 'scrollTimer', setTimeout(function() {
		        Directory.userScrolling = false;
		    }, 250));
		})

	},

	checkPositions: function(el){
		
		// console.log(el.attr('id'), el.offset().top, el.position().top);

		var top = Math.floor(el.position().top)

		if(top <= 0 && top >= -150){

			if(this.selected != el.attr('url')){
				this.selected = el.attr('url');
				this.update(el)
			}
		}
	},

	update: function(item){

		if(App.debug){
			console.log('--- Scroller.update -----------------------------');
			console.log('url', item.attr('url'));
		}

		Router.route(item.attr('title'),  item.attr('url'));
	},
}